import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger } from '../utils';

export const savedBillingAddressChangedConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.SAVED_BILLING_ADDRESS_CHANGED,
  handler: ({ detail }) => {
    logger('Saved Billing Address Changed');
    console.log(detail);
  },
};
